
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intellectualProperty",
      function () {
        return require("private-next-pages/intellectualProperty.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intellectualProperty"])
      });
    }
  